import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-hopper-wizard-complete',
  templateUrl: './connect-hopper-wizard-complete.component.html',
  styleUrls: ['./connect-hopper-wizard-complete.component.scss'],
})
export class ConnectHopperWizardCompleteComponent implements OnInit {
  @Output() done = new EventEmitter()

  ngOnInit(): void {}
}
